// Curated sample sets shown to new users during onboarding.
// Each set has embedded tune data so no cross-user Firestore reads are needed.
// Tune fields match the schema used by the rest of the app.

const makeTune = (title, type, key, genre, link1 = '') => ({
  title, type, key, genre, mode: 'tunes', link1,
  isSample: true,
  status: '', composer: '', chords: '', lyrics: '', quickNote: '', notes: '',
  link2: '', link3: '', imageUrl: '', source: '', abc: '',
  sessions: [], recordings: [], customTags: [],
});

export const SAMPLE_SETS = [
  {
    id: 'sample-irish-reels',
    title: 'Classic Irish Reels',
    genre: 'Irish',
    description: '3 well-known session reels — a great starting point.',
    tunes: [
      makeTune('The Silver Spear', 'Reel', 'D major', 'Irish', 'https://thesession.org/tunes/20'),
      makeTune('The Morning Dew', 'Reel', 'D major', 'Irish', 'https://thesession.org/tunes/130'),
      makeTune('The Bucks of Oranmore', 'Reel', 'G major', 'Irish', 'https://thesession.org/tunes/8'),
    ],
  },
  {
    id: 'sample-irish-jigs',
    title: 'Irish Jig Set',
    genre: 'Irish',
    description: '3 popular session jigs in G and E dorian.',
    tunes: [
      makeTune('The Kesh Jig', 'Jig', 'G major', 'Irish', 'https://thesession.org/tunes/74'),
      makeTune("Morrison's Jig", 'Jig', 'E dorian', 'Irish', 'https://thesession.org/tunes/59'),
      makeTune('The Lilting Banshee', 'Jig', 'G major', 'Irish', 'https://thesession.org/tunes/38'),
    ],
  },
  {
    id: 'sample-old-time',
    title: 'Old-Time Sampler',
    genre: 'Old-Time',
    description: 'Three old-time standards to get you started.',
    tunes: [
      makeTune('Old Joe Clark', 'Breakdown', 'A mixolydian', 'Old-Time'),
      makeTune('Cripple Creek', 'Breakdown', 'A major', 'Old-Time'),
      makeTune('Shady Grove', 'Ballad', 'D dorian', 'Old-Time'),
    ],
  },
  {
    id: 'sample-bluegrass',
    title: 'Bluegrass Standards',
    genre: 'Bluegrass',
    description: 'Three essential bluegrass instrumentals.',
    tunes: [
      makeTune('Foggy Mountain Breakdown', 'Breakdown', 'G major', 'Bluegrass'),
      makeTune('Salt Creek', 'Breakdown', 'A major', 'Bluegrass'),
      makeTune('Blackberry Blossom', 'Breakdown', 'G major', 'Bluegrass'),
    ],
  },
  {
    id: 'sample-klezmer',
    title: 'Klezmer Starters',
    genre: 'Klezmer',
    description: 'A handful of classic klezmer pieces.',
    tunes: [
      makeTune('Der Gasn Nigun', 'Freylekhs', 'D minor', 'Klezmer'),
      makeTune('Bublitchki', 'Bulgar', 'A minor', 'Klezmer'),
      makeTune('Reb Dovidl', 'Hora', 'G minor', 'Klezmer'),
    ],
  },
];
